


















































































import { Vue, Component } from 'vue-property-decorator';
// import { State } from 'vuex-class';
// import store from '@/store';
import * as api from '@/api';

import CategoryTree from '@/views/cti/components/category-tree.vue';
/**
 * 美维工单 迁移页面
 *
 * @author liyuyao
 * @date 07/09/2019
 */
@Component({
    components: {
        CategoryTree
    }
})
export default class HelpdeskTransferIndex extends Vue {
    projectId: number = null;
    categoryTreeList: any = [];
    mwCtiList: any = [];
    activeStep: number = 0;
    projectTip: string = '可以在美维工单链接中查看项目id，示例：https://helpdesk.sankuai.com/setting/project/400，400即为项目id';

    btnLoading: boolean = false;

    limit: number = 40;
    currentPage: number = 1;

    showLoadMore: boolean = false;

    mounted() {
        this.getCategoryTree();
    }
    clearProjectList() {
        this.mwCtiList = [];
    }
    async getProjectList() {
        this.mwCtiList = await this.getHelpdeskCTI();
    }
    async getHelpdeskCTI() {
        if (!this.projectId) {
            return;
        }
        const res = await api.ctiApi.getHelpdeskCTI(this.projectId, this.currentPage, this.limit);
        const { code, data } = res;
        let mwCtiList = [];
        // 前端过滤空CTI后 total和展示内容对不上 无法通过比较total判断分页
        this.showLoadMore = data.items && data.items.length === this.limit;
        // 过滤可能存在的空CTI
        if (code === 200) {
            const mwlist = data.items.filter(x => x.mwCate1Name);
            mwCtiList = await Promise.all(
                mwlist.map(async mwCti => {
                    if (mwCti.itemId) {
                        const ctiInfo = await this.getItemDetail(mwCti.itemId);
                        return Object.assign(mwCti, ctiInfo);
                    } else {
                        return mwCti;
                    }
                })
            );
        }
        return mwCtiList;
    }
    async handleLoadMore() {
        this.currentPage++;
        const data = await this.getHelpdeskCTI();
        this.mwCtiList.push(...data);
    }
    async getCategoryTree() {
        try {
            const res = await api.ctiApi.getCategoryTreeTotal();
            this.categoryTreeList = res.data.items;
        } catch (e) {
            console.log(e);
        }
    }
    mwCtiDisplay(mwCti) {
        if (mwCti) {
            let catalog = mwCti.mwCate1Name;
            if (mwCti.mwCate2Name) {
                catalog += '/' + mwCti.mwCate2Name;
            }
            if (mwCti.mwCate3Name) {
                catalog += '/' + mwCti.mwCate3Name;
            }
            return catalog;
        }
    }
    async handleCategoryChange(catalog, index, ifManual) {
        if (ifManual) {
            return;
        }
        const mwCti = this.mwCtiList[index];
        if (mwCti.itemId) {
            await this.removeBindToCti(mwCti.id);
        }
        const params = {
            mwProjectId: this.projectId,
            mwCate1Name: mwCti.mwCate1Name,
            mwCate1Id: mwCti.mwCate1Id,
            mwCate2Name: mwCti.mwCate2Name,
            mwCate2Id: mwCti.mwCate2Id,
            mwCate3Name: mwCti.mwCate3Name,
            mwCate3Id: mwCti.mwCate3Id,
            itemName: catalog.itemName,
            itemId: catalog.itemId
        };
        await this.bindMwToCti(params, index);
        for (const key in catalog) {
            this.mwCtiList[index][key] = catalog[key];
        }
    }
    async removeBindToCti(configId) {
        try {
            await api.ctiApi.removeBindToCti(configId);
        } catch (e) {
            console.log(e);
        }
    }
    async bindMwToCti(params, index) {
        try {
            const res = await api.ctiApi.bindMwToCti(params);
            const { code, data } = res;
            if (code === 200) {
                this.$mtd.message.success('绑定成功');
                this.mwCtiList[index].id = data.id;
            }
        } catch (e) {
            console.log(e);
        }
    }
    async getItemDetail(itemId) {
        if (!itemId) {
            return;
        }
        const res = await api.ctiApi.getItemInfo(itemId);
        const { code, data } = res;
        if (code === 200) {
            return {
                categoryName: data.categoryName,
                categoryId: data.categoryId,
                typeName: data.typeName,
                typeId: data.typeId,
                itemName: data.itemName,
                itemId: data.itemId
            };
        } else {
        }
    }
    cancelBack() {
        if (this.activeStep === 0) {
            this.$router
                .push({
                    name: 'cti'
                })
                .catch(e => e);
        } else {
            this.activeStep--;
        }
    }
    nextOperate() {
        if (this.activeStep > 0) {
            this.checkTransfer();
        } else {
            this.activeStep++;
        }
    }
    checkTransfer() {
        this.$mtd
            .confirm({
                message: '迁移后的TT权限均为「公开」，确定要开始迁移吗？',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '确定',
                onOk: async () => {
                    this.mwTransfer();
                }
            })
            .catch(e => e);
    }
    async mwTransfer() {
        this.btnLoading = true;
        try {
            // 发起迁移tt
            const res = await api.ctiApi.mwTransfer(this.projectId);
            const { code } = res;
            if (code === 200) {
                this.activeStep++;
            } else {
                this.$mtd.message.error('请求失败');
            }
        } catch (e) {
            console.log(e);
        }
        this.btnLoading = false;
    }
    get submitText() {
        return this.activeStep > 0 ? '发起迁移' : '下一步';
    }
    get cancelText() {
        return this.activeStep > 0 ? '上一步' : '取消';
    }
    get checkMwList() {
        return this.mwCtiList.filter(mwCti => mwCti.itemId);
    }
}
